var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4813_34585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99464 6.58984C8.11781 6.58984 6.59071 8.11694 6.59071 9.99392C6.59071 11.8707 8.11781 13.3978 9.99464 13.3978C11.8716 13.3978 13.3987 11.8707 13.3987 9.99392C13.3987 8.11694 11.8716 6.58984 9.99464 6.58984Z",
    fill: "#062A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4142 9.40794H17.2636C16.9796 5.85311 14.1354 3.00872 10.5804 2.72491V0.585784C10.5804 0.262298 10.3181 0 9.99464 0C9.67115 0 9.40886 0.262298 9.40886 0.585784V2.72491C5.85387 3.00872 3.00964 5.85311 2.72567 9.40794H0.585784C0.262298 9.40794 0 9.67024 0 9.99388C0 10.3174 0.262298 10.5797 0.585784 10.5797H2.72567C3.00964 14.1345 5.85387 16.9789 9.40886 17.2628V19.4018C9.40886 19.7253 9.67115 19.9876 9.99464 19.9876C10.3183 19.9876 10.5804 19.7253 10.5804 19.4018V17.2628C14.1354 16.9789 16.9798 14.1345 17.2636 10.5797H19.4142C19.7377 10.5797 20 10.3174 20 9.99388C20 9.67024 19.7377 9.40794 19.4142 9.40794ZM9.99464 16.1148C6.61955 16.1148 3.87374 13.3688 3.87374 9.99388C3.87374 6.61879 6.61955 3.87283 9.99464 3.87283C13.3697 3.87283 16.1155 6.61879 16.1155 9.99388C16.1155 13.3688 13.3697 16.1148 9.99464 16.1148Z",
    fill: "#062A41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4813_34585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.cab5c0b27cd9fcea2e7458de2e2deecb.svg";
export { ForwardRef as ReactComponent };